import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityState } from '@/shared/types/entity';
import { trialFunnelErrorsApi } from '../api';
import type { TrialFunnelError, TrialFunnelErrorFilters } from '../types';

const initialState: EntityState<TrialFunnelError, TrialFunnelErrorFilters> = {
  items: [] as TrialFunnelError[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    dateFrom: null,
    dateTo: null,
  },
};

const { actions, reducer } = createEntitySlice<TrialFunnelError, TrialFunnelErrorFilters, never>({
  name: 'trialFunnelErrorsEntity',
  api: {
    getList: trialFunnelErrorsApi.getList,
    getOne: () => Promise.reject(new Error('Trial funnel errors are read-only')),
    create: () => Promise.reject(new Error('Trial funnel errors are read-only')),
    update: () => Promise.reject(new Error('Trial funnel errors are read-only')),
    delete: () => Promise.reject(new Error('Trial funnel errors are read-only')),
  },
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.trialFunnelErrorsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };
    if (filters.search) params.search = filters.search;
    if (filters.dateFrom) params.dateFrom = filters.dateFrom;
    if (filters.dateTo) params.dateTo = filters.dateTo;
    return params;
  },
});

export const {
  fetchItems: fetchTrialFunnelErrors,
  setPage: setTrialFunnelErrorsPage,
  setPerPage: setTrialFunnelErrorsPerPage,
  setFilters: setTrialFunnelErrorsFilters,
} = actions;

export const trialFunnelErrorsReducer = reducer;
